<template>
    <div
        class="modal fade"
        data-bs-backdrop="static"
        tabindex="-1"
        :aria-label="title"
        ref="modalFormElement">
        <div
            class="modal-dialog modal-dialog-centered"
            :class="{'modal-dialog-scrollable': scrollable}"
            :style="{maxWidth: `${width}px`}">
            <form
                class="modal-content"
                novalidate
                @submit.prevent="submit">
                <div class="modal-header">
                    <h4 class="modal-title">{{ title }}</h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <div class="button-wrapper">
                        <b-button
                            variant="secondary"
                            data-bs-dismiss="modal"
                            type="button">
                            Cancel
                        </b-button>
                        <b-button
                            variant="primary"
                            :loading="loading"
                            type="submit">
                            {{ submitButton }}
                        </b-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import {Modal} from "bootstrap";
import {BButton} from "./../BButton";

const model = defineModel({type: Boolean});

const props = withDefaults(
    defineProps<{
        title?: string;
        width?: number;
        submitButton?: string;
        loading?: boolean;
        scrollable?: boolean;
    }>(),
    {
        width: 750,
        loading: false,
        submitButton: "Save",
        scrollable: true,
    }
);

const modalFormElement = ref<HTMLElement>();
const triggerElement = ref<HTMLElement | null>(null);
let modelObject: Modal;

const emit = defineEmits(["submit"]);

onMounted(() => {
    modelObject = new Modal(modalFormElement.value!);

    modalFormElement.value!.addEventListener("hidden.bs.modal", (event) => {
        model.value = false;

        if (triggerElement.value?.isConnected) {
            triggerElement.value.focus();
        }
        triggerElement.value = null;
    });
});

const submit = function () {
    emit("submit");
};

function _show() {
    triggerElement.value = document.activeElement as HTMLElement | null;
    modelObject.show();
    model.value = true;
}

function _hide() {
    modelObject.hide();
    model.value = false;
}

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);
</script>
<style lang="scss">
.button-wrapper {
    display: inline grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 0.5rem;
}
</style>
